module.exports = __webpack_public_path__ + "static/media/Detail_MockUp_MVGranite.051d7a41.png";